export const environment = {
	production: true,
	hmr: false,

	firebase: {
		apiKey: "AIzaSyDxpa_F0pNQu_U1_FnO2fGV4CYmZAgYfR8",
		authDomain: "aitana-angular.firebaseapp.com",
		databaseURL: "https://aitana-angular.firebaseio.com",
		projectId: "aitana-angular",
		storageBucket: "aitana-angular.appspot.com",
		messagingSenderId: "436354205196",
		appId: "1:436354205196:web:da1eb1c1aadaad798e1029",
		measurementId: "G-V747HPJFBM"
	},
	WEBSOCKET_URL: "/wss",
	WEBSOCKET_STREAM_VIDEO_URL: "http://localhost:3002",
	API_URL: "/api",
	API_AISTATISTICS: "https://wsaistatistics.aitanasolutions.com",
	URL_AISTATISTICS: "https://aistatistics.aitanasolutions.com",
	URL_VASCULA_LOCAL: "http://localhost:5000",
	clientSecret: "MzUzYjMwMmM0NDU3NGY1NjUwNDU2ODdlNTM0ZTdkNmE6Mjg2OTI0Njk3ZTYxNWE2NzJhNjQ2YTQ5MzU0NTY0NmM=",
	linkNewAitana: "https://new.aitana.cygitsolutions.com",
	entorno: "corely",

	TOKEN_FAGOR: "f61fdac7730179b59e3e05647cce07cc10c4579f73b056571418bddac413c295"
};

export const prioridades = [
	{
		id: 1,
		nombre: "Muy baja",
		color: "#8bc34a"
	},
	{
		id: 2,
		nombre: "Baja",
		color: "#ffeb3b"
	},
	{
		id: 3,
		nombre: "Media",
		color: "#fb8c00"
	},
	{
		id: 4,
		nombre: "Urgente",
		color: "#ff5722"
	},
	{
		id: 5,
		nombre: "Muy urgente",
		color: "#d50000"
	}
];

export const estados_ticket = [
	{
		id: "new",
		nombre: "Nueva"
	},
	{
		id: "assign",
		nombre: "En Curso (Asignado)"
	},
	{
		id: "waiting",
		nombre: "En espera"
	},
	{
		id: "plan",
		nombre: "En curso (Planificado)"
	},
	{
		id: "old_done",
		nombre: "Cerrada (Resuelta)"
	},
	{
		id: "old_notdone",
		nombre: "Cerrada (No Resuelta)"
	}
];

export const tipos_cliente = [
	{
		id: 1,
		nombre: "Particular"
	},
	{
		id: 2,
		nombre: "Empresa"
	}
];
